export default "__VITE_ASSET__BL8Il$6$__"